import { PlatoLogoWithText } from '@plato/ui-legacy/assets/icons/plato-logo-with-text';
import { useState, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

const pulseDurationMs = 1200;

/** Splash while the app boots, before the shell renders. */
export function AppBootScreen(): ReactElement {
    const { t } = useTranslation('common');
    // Page-clock phase, so remounts between boot phases don't restart the pulse.
    const [phaseMs] = useState(() => performance.now() % pulseDurationMs);

    return (
        <div className="flex h-dvh w-screen flex-col items-center gap-relaxed bg-container">
            <span aria-hidden className="grow-[1]" />
            <PlatoLogoWithText className="h-10 w-auto" />
            {/* smell: same as ai-chat ThinkingDots — extraction candidate */}
            <span role="status" aria-label={t('loading')} className="flex items-center gap-tight">
                {[0, 1, 2].map((index) => (
                    <span
                        key={index}
                        aria-hidden
                        className="block size-1.5 animate-pulse rounded-full bg-content-weaker"
                        style={{
                            animationDuration: `${pulseDurationMs}ms`,
                            animationDelay: `${index * 200 - phaseMs}ms`,
                        }}
                    />
                ))}
            </span>
            <span aria-hidden className="grow-[2]" />
        </div>
    );
}
